"use client";
import { jsx as d } from "react/jsx-runtime";
import { memo as l, useCallback as k, useEffect as E } from "react";
import { D as P, M as h } from "../../../ModalBase-CANcLFh0.js";
import { usePortalContext as w } from "./PortalProvider.js";
const x = l(
  ({
    portalId: o,
    variant: t = "auto",
    onClose: e,
    dismissible: a = !0,
    classNames: m,
    style: s,
    children: f,
    ...i
  }) => {
    const { currentPortal: r, closePortal: c } = w(), p = t === "fixed" || t === "auto" ? "bottom" : t, u = k(
      (n) => {
        n.key === "Escape" && e != null && e();
      },
      [c, e]
    );
    return E(() => {
      if (o !== r)
        return;
      const n = (y) => u(y);
      return document.body.addEventListener("keydown", n), () => {
        document.body.removeEventListener("keydown", n);
      };
    }, [u, r, o]), /* @__PURE__ */ d(
      P.Root,
      {
        shouldScaleBackground: !0,
        direction: p,
        dismissible: a,
        open: o === r,
        onOpenChange: e || c,
        ...i,
        children: /* @__PURE__ */ d(
          h,
          {
            isOpen: o === r,
            dismissible: a,
            variant: t,
            classNames: m,
            style: s,
            children: f
          }
        )
      }
    );
  }
);
x.displayName = "PortalModal";
export {
  x as PortalModal
};
